export const getSfId = () => {
    var sfid = "";
    const userString = sessionStorage.getItem("user");
    if (userString !== null) {
        var user = {};
        try {
            user = JSON.parse(userString);
        }
        catch (ex) {
            console.log("JSONParseUser", ex);
        }
        sfid = user.sfid;
    }
    return sfid;
}